// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___8UGLT","header":"styles__header___3uChR","title":"styles__title___2poqY","close":"styles__close___RFBbA","submit":"styles__submit___1HzOz"};